import { Map, MapMarker } from 'react-kakao-maps-sdk';

import * as S from './style';

const Maps = () => (
	<S.MapContainer>
		<S.ContentBox>
			<S.ContentTitle>
				<p>사무국 안내</p>
			</S.ContentTitle>
			<S.MapsContent>
				<span>사업장 주소: 서울시 송파구 법원로 127, 316호(문정동, 대명벨리온)</span>
				<S.MapsContentSubContainer>
					<span>TEL : (02) 6713-1968</span>
					<span>FAX : (02) 6713-1969</span>
					<span>E-Mail : scsk1968@naver.com</span>
				</S.MapsContentSubContainer>
			</S.MapsContent>

			<div>
				<S.ImgMapBox style={{ width: '100%', maxWidth: '844px' }}>
					<Map center={{ lat: 37.48623, lng: 127.1188 }} style={{ width: '100%', height: '400px' }} level={3}>
						<MapMarker position={{ lat: 37.48623, lng: 127.1188 }} />
					</Map>
				</S.ImgMapBox>
				<S.MapBox>
					<S.MapContent>
						<div className="menu_box">지하철 이용시</div>
						<p>8호선 문정역 4번출구에서 도보로 5분 (309M)</p>
					</S.MapContent>
				</S.MapBox>
			</div>
		</S.ContentBox>
	</S.MapContainer>
);
export default Maps;
